import { Link } from 'react-router-dom';
import MagicLinkForm from '../components/MagicLinkForm';

export default function LoginPage() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-md space-y-8">
        {/* Header */}
        <div className="text-center space-y-2">
          <h1 className="text-3xl font-bold tracking-tight text-foreground">
            Welcome to ProductWorkshop
          </h1>
          <p className="text-muted-foreground">
            Sign in to submit and vote on feature requests
          </p>
        </div>

        {/* Form Card */}
        <div className="bg-card border border-border rounded-lg p-8 shadow-sm">
          <MagicLinkForm />
        </div>

        {/* Footer */}
        <div className="space-y-3">
          <p className="text-center text-sm text-muted-foreground">
            No password required. We'll send you a secure link to sign in.
          </p>
          <p className="text-center text-xs text-muted-foreground">
            By signing in, you agree to our{' '}
            <Link to="/terms" className="underline hover:text-foreground transition-colors">
              Terms of Service
            </Link>{' '}
            and{' '}
            <Link to="/privacy" className="underline hover:text-foreground transition-colors">
              Privacy Policy
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
